module.exports = __webpack_public_path__ + "static/media/invest.9131b085.png";